/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ParkerType = {
    GuestParker: 'GuestParker',
    RegisteredParker: 'RegisteredParker'
} as const;
export type ParkerType = typeof ParkerType[keyof typeof ParkerType];

